<cv-module-custom-setting-section *ngIf="moduleManager.settingsView == 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">View Setting</div>
    <div class="custom-setting-section-context">{{ context }}</div>
    <div class="custom-setting-section-body">
        <div class="flex-fill d-flex flex-column" *ngIf="initialized">
            <div class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Expanded_Summary" langKey="Primary_View">Primary View</div>
            <select class="form-control form-control-lg" [(ngModel)]="selectedPrimaryView" (ngModelChange)="onPrimaryViewChange()">
                <option [ngValue]="0"><span cvLocalizedText langSection="Expanded_Summary" langKey="Employee_Group">Employee Group</span></option>
                <option [ngValue]="1"><span cvLocalizedText langSection="Expanded_Summary" langKey="Contact_Group">Contact Group</span></option>
            </select>
        </div>
        <div class="flex-fill d-flex flex-column mt-2" *ngIf="initialized">
            <div class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Expanded_Summary" langKey="Employee_Group_View_By">Employee Group View By</div>
            <select class="form-control form-control-lg" [(ngModel)]="selectedEmpGroup">
                <option *ngFor="let group of empGroups; let $index = index" [ngValue]="$index">{{ group }}</option>
            </select>
        </div>
        <div class="flex-fill d-flex flex-column mt-2" *ngIf="initialized">
            <div class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Expanded_Summary" langKey="Contact_Group_View_By">Contact Group View By</div>
            <select class="form-control form-control-lg" [(ngModel)]="selectedRecGroup">
                <option *ngFor="let group of recGroups; let $index = index" [ngValue]="$index">{{ group }}</option>
            </select>
        </div>
    </div>
</cv-module-custom-setting-section>

<ng-container *ngIf="moduleManager.settingsView == 'modal' && initialized">
    <div cvModuleLegacyCustomSettingSection position="top" [moduleManager]="moduleManager">
        <span class="settingPlaceholder settingsSectionTitle ng-scope">View Setting</span>
        <div class="flex-fill d-flex flex-column">
            <div class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Expanded_Summary" langKey="Primary_View">Primary View</div>
            <select class="form-control form-control-lg" [(ngModel)]="selectedPrimaryView" (ngModelChange)="onPrimaryViewChange()">
                <option [ngValue]="0"><span cvLocalizedText langSection="Expanded_Summary" langKey="Employee_Group">Employee Group</span></option>
                <option [ngValue]="1"><span cvLocalizedText langSection="Expanded_Summary" langKey="Contact_Group">Contact Group</span></option>
            </select>
        </div>
        <div class="flex-fill d-flex flex-column mt-2">
            <div class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Expanded_Summary" langKey="Employee_Group_View_By">Employee Group View By</div>
            <select class="form-control form-control-lg" [(ngModel)]="selectedEmpGroup">
                <option *ngFor="let group of empGroups; let $index = index" [ngValue]="$index">{{ group }}</option>
            </select>
        </div>
        <div class="flex-fill d-flex flex-column mt-2">
            <div class="body-2 color-whaleTail mb-1" cvLocalizedText langSection="Expanded_Summary" langKey="Contact_Group_View_By">Contact Group View By</div>
            <select class="form-control form-control-lg" [(ngModel)]="selectedRecGroup">
                <option *ngFor="let group of recGroups; let $index = index" [ngValue]="$index">{{ group }}</option>
            </select>
        </div>
    </div>
</ng-container>